import { useMemo, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { getPathWithBaseURL } from '../../utils/Common';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import styled from "styled-components";
//import pdfjsWorker from 'pdfjs-dist/build/pdf.min.mjs';

const PdfViewerContainer = styled.div`
    width: 620px;
    max-height:860px;
    overflow:auto;
`

// console.log("Pred pdfjs.GlobalWorkerOptions.workerSrc");
// console.log("pdfjs.GlobalWorkerOptions.workerSrc", pdfjs.GlobalWorkerOptions.workerSrc);

//pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;x
// Prefer CDN-hosted worker (valid TLS). Using the local dynamic import (mjs) can fail in dev
// when serving over HTTPS with a self-signed certificate (ERR_CERT_AUTHORITY_INVALID).
// Use the unpkg CDN which has a valid certificate and avoids the browser blocking the
// dynamically imported module.
//pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

// Alternative that sometimes works (local ESM worker):
// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

interface PdfViewerArgs {
    pdfDocumentPath: string
}

const PdfViewer = ({ pdfDocumentPath }: PdfViewerArgs) => {
    
// console.log("Pred2 pdfjs.GlobalWorkerOptions.workerSrc");
// console.log("2 pdfjs.GlobalWorkerOptions.workerSrc", pdfjs.GlobalWorkerOptions.workerSrc);

    const [numPages, setNumPages] = useState<number | null>(null);

    const memoizedFile = useMemo(() => {
        const pdfUrl = `${window.location.origin}${pdfDocumentPath.startsWith('/') ? pdfDocumentPath : '/' + pdfDocumentPath}`;
        return pdfUrl;
    }, [pdfDocumentPath]);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    return (

        <PdfViewerContainer>
            <Document
                file={memoizedFile}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                {numPages && Array.from(new Array(numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document>
        </PdfViewerContainer>
        
        // <div style={{ textAlign: 'center' }}>
        //     <Document file={pdfPlayerArgs.pdfDocumentPath} onLoadSuccess={onDocumentLoadSuccess}>
        //         <Page pageNumber={pageNumber} />
        //     </Document>
        //     <div>
        //         <button
        //             disabled={pageNumber <= 1}
        //             onClick={() => setPageNumber((prev) => prev - 1)}
        //         >
        //             Previous
        //         </button>
        //         <span>
        //             Page {pageNumber} of {numPages}
        //         </span>
        //         <button
        //             disabled={pageNumber >= (numPages || 0)}
        //             onClick={() => setPageNumber((prev) => prev + 1)}
        //         >
        //             Next
        //         </button>
        //     </div>
        // </div>
    );
}

export default PdfViewer